interface QueryErrorProps {
  message?: string;
  onRetry?: () => void;
}

export function QueryError({ message = 'Something went wrong', onRetry }: QueryErrorProps) {
  return (
    <div
      className="rounded-xl border border-red-200 bg-red-50 p-6 text-center"
      role="alert"
      aria-live="polite"
    >
      <p className="text-sm font-medium text-red-800">{message}</p>
      {onRetry ? (
        <button type="button" onClick={onRetry} className="btn-primary mt-4 text-sm">
          Try Again
        </button>
      ) : null}
    </div>
  );
}
